import React, { useEffect } from "react";
import { Spin } from "antd";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  clearBillingCheckoutReturnPath,
  DEFAULT_BILLING_RETURN_PATH,
  canUseSubscriptionFeatures,
  getBillingCheckoutReturnPath,
  sanitizeBillingReturnPath,
  setBillingCheckoutSuccess,
} from "../../shared/billing";
import { types } from "../../redux/action-types";
import "./PaymentSuccess.css";

export default function PaymentSuccess() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!canUseSubscriptionFeatures()) {
      clearBillingCheckoutReturnPath();
      history.replace(DEFAULT_BILLING_RETURN_PATH);
      return;
    }

    const params = new URLSearchParams(location.search || "");
    const returnTo = sanitizeBillingReturnPath(
      params.get("returnTo") || getBillingCheckoutReturnPath()
    );

    dispatch({ type: types.FETCH_CREDITS_BALANCE_REQUESTED });

    setBillingCheckoutSuccess({
      returnTo,
      message:
        "Your plan purchase was completed successfully. You can continue from where you left off.",
    });
    clearBillingCheckoutReturnPath();
    history.replace(returnTo || DEFAULT_BILLING_RETURN_PATH);
  }, [history, location.search]);

  return (
    <div className="payment-success-page">
      <div className="payment-success-card">
        <Spin size="large" />
        <p className="payment-success-text" style={{ marginTop: 24 }}>
          Finalizing your payment...
        </p>
      </div>
    </div>
  );
}
